import React, { useEffect, useState } from "react";
import { Box, Button, Modal } from "@mui/material";
import { ThreeDots } from "react-loader-spinner";
import { DealerApiWrapper, modalStyle } from "../style/DealerApiWrapper";
import { PER_PAGE_OPTIONS } from "../helpers";

/**
 * Previous / Next for the Dealer API lists, which use simple pagination (next_page_url /
 * prev_page_url, no total — the shared Pagination component needs a page count).
 */
export const SimplePager = ({ page, hasPrev, hasNext, onChange }) =>
  hasPrev || hasNext ? (
    <div className="pager">
      <Button variant="outlined" disabled={!hasPrev} onClick={() => onChange(page - 1)} sx={{ textTransform: "none" }}>
        Previous
      </Button>
      <span className="muted">Page {page}</span>
      <Button variant="outlined" disabled={!hasNext} onClick={() => onChange(page + 1)} sx={{ textTransform: "none" }}>
        Next
      </Button>
    </div>
  ) : null;

export const LoadingRow = ({ colSpan }) => (
  <tbody>
    <tr>
      <td colSpan={colSpan}>
        <div className="d-flex justify-content-center three-dot">
          <ThreeDots height="150" width="150" radius="9" color="#637df4" ariaLabel="three-dots-loading" visible={true} />
        </div>
      </td>
    </tr>
  </tbody>
);

export const PerPageSelect = ({ value, onChange }) => (
  <select className="filter-select" value={value} onChange={(e) => onChange(e.target.value)}>
    <option value="">Per Page</option>
    {PER_PAGE_OPTIONS.map((n) => (
      <option key={n} value={n}>
        {n}
      </option>
    ))}
  </select>
);

/**
 * Confirmation, with an optional note where the API stores one (approve / reject a request and
 * revoke an access keep it as the decision note; revoking a key takes none: withNote={false}).
 * `audience` explains who reads the note: the dealer sees decision and revocation notes.
 */
export const NoteModal = ({ open, title, message, audience, confirmLabel, danger, busy, onConfirm, onClose, withNote = true }) => {
  const [note, _note] = useState("");

  useEffect(() => {
    if (open) _note("");
  }, [open]);

  return (
    <Modal open={open} onClose={() => !busy && onClose()} aria-labelledby="dealer-api-note-modal-title">
      <Box sx={modalStyle}>
        <DealerApiWrapper>
          {/* The title says which confirmation this is — approve, reject, revoke access or revoke a
              key — so it is what should name the dialog to a screen reader. */}
          <h4 className="mb-3" id="dealer-api-note-modal-title">{title}</h4>
          {message && <p>{message}</p>}
          {withNote && (
            <>
              <label className="form-label fw-bold" htmlFor="dealer-api-note">
                Note <span className="muted">(optional{audience ? `, ${audience}` : ""})</span>
              </label>
              <textarea
                id="dealer-api-note"
                className="form-control"
                rows={4}
                maxLength={1000}
                value={note}
                onChange={(e) => _note(e.target.value)}
              />
            </>
          )}
          <div className="d-flex justify-content-end gap-2 mt-4">
            <Button variant="outlined" disabled={busy} onClick={onClose} sx={{ textTransform: "none" }}>
              Cancel
            </Button>
            <Button
              variant="contained"
              color={danger ? "error" : "primary"}
              disabled={busy}
              onClick={() => onConfirm(withNote && note.trim() !== "" ? note.trim() : null)}
              sx={{ textTransform: "none", fontWeight: 600 }}
            >
              {confirmLabel}
            </Button>
          </div>
        </DealerApiWrapper>
      </Box>
    </Modal>
  );
};
